import React, { createContext, useState } from "react"

export const CommonContext = createContext()

export const CommonContextProvider = ({ children }) => {
  const [data, setData] = useState([])
  const [columns, setColumns] = useState([])
  const [showToast, setShowToast] = useState(false)
  const [toastMsg, setToastMsg] = useState(false)
  const [confirmToast, setConfirmToast] = useState({
    show: false,
    labelName: "",
    message: "",
    actionType: "",
    confirmBtnText: "Confirm",
    onClick: () => {},
  })

  return (
    <CommonContext.Provider
      value={{
        data,
        setData,
        columns,
        setColumns,
        showToast,
        setShowToast,
        toastMsg,
        setToastMsg,
        confirmToast,
        setConfirmToast,
      }}
    >
      {children}
    </CommonContext.Provider>
  )
}
